import { Card, CardBody, Col } from "reactstrap";
import { DefaultTouchspinTitle } from "../../../../../../Constants/Constants";
import CommonTouchspin from "../Common/CommonTouchspin";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DefaultTouchspinData, TouchspinSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormWidgets";

const DefaultTouchspin=()=> {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={DefaultTouchspinTitle} span={TouchspinSubTitle} />
        <CardBody className="common-flex">
          {DefaultTouchspinData.map((data, index) => (
            <CommonTouchspin key={index} color={data} btnClass={`touchspin-${data}`} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
}
export default DefaultTouchspin